module.exports = __webpack_public_path__ + "static/media/Avengers_Endgame_-_Trailer_Theme_Piano.2e0d5b63.mp3";